var _defs, _ellipse, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtilarIkonu3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#55c595;}.cls-2,.cls-3{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:30px;}.cls-2{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xC7al\u0131\u015Fma Y\xFCzeyi 40mdpi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 534.91,
    cy: 543.34,
    rx: 294.5,
    ry: 189.36,
    transform: "translate(-121 932.08) rotate(-76.1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M791.86,480.91,890.7,587.3c4.33,4.65,10.58,4.16,14.31-1.13l85-120.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.84,503.27a363,363,0,0,0-4.54,57.37c0,199.19,161.46,360.65,360.65,360.65,160.28,0,296.13-104.55,343.08-249.17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.81,417.55C261.19,289.56,388.6,200,537,200c199.18,0,360.64,161.46,360.64,360.64q0,14.05-1.06,27.87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M665.47,495.32a2.57,2.57,0,0,0-2.07-4.1H562.71c-5.92,0-5.9,0-3.17-5.39l85.08-168.62c2.14-4.25,0-7.73-4.75-7.73q-59.52,0-119-.07c-3.14,0-4.67,1-5.85,4q-25.28,62.44-50.77,124.82-25.85,63.48-51.69,127c-1.54,3.8-1.49,3.92,2.79,3.92H516.67c4.85,0,5,.21,3.32,4.85q-12.86,36.36-25.7,72.73Q471,712.55,447.79,778.42l-2.15,6.11,5,2.64Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.14,612.07,189.3,505.68C185,501,178.72,501.52,175,506.81L90,627.41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtilarIkonu3);
export default __webpack_public_path__ + "static/media/artilarIkonu3.3ba5ee39dca725d6294318076cdca9ce.svg";
export { ForwardRef as ReactComponent };